module.exports = __webpack_public_path__ + "03_hige_gray.45145f30.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/okuta/dad/layer3/03_hige_gray.png
// module id = yd/i
// module chunks = 0